<script>
  import relatorioTecnicoProjetoServico from '../servico';
  import DadosCadastrais from './compartilhado/FormDadosCadastrais.vue';
  import AdicionarArquivos from '~componentes/FormAdicionarArquivos.vue';
  import ListaDeArquivos from '~componentes/ListaDeArquivos.vue';

  export default {
    components: { DadosCadastrais, AdicionarArquivos, ListaDeArquivos },
    data() {
      return {
        botaoSalvar: false,
        camposReadOnly : true,
        mostrarFormulario: false,
        relatorioTecnicoProjeto: this.camposRelatorioTecnico(),
        carregando: true,
        configuracao: this.$storage.configuracao(),
        arquivos: [], 
      }
    },
    mounted() {
      this.$root.tituloDaPagina = 'Relatório Técnico Projeto - Editar #' + this.$route.params.numeroRelatorio;
      this.$root.botaoAcaoMostrar = false;
    },
    methods: {
      setaVisibilidade() {
        this.botaoSalvar = ((parseInt(this.relatorioTecnicoProjeto.idResponsavelEnvio) === 0) && this.mostrarFormulario);
        this.camposReadOnly = (parseInt(this.relatorioTecnicoProjeto.idResponsavelEnvio) > 0);
      },
      salvar() {
        $('#salvar').button('loading');
        
        this.$refs.dadosCadastrais
          .validarDados()
          .then(valido => {
            if (!valido) {
              $('#tabs a[href="#tab-dados-cadastrais"]').tab('show');
            }

            return valido;
          })
          .then(this.enviar)
          .then(() => {
            this.$router.push({ name: 'relatorio-tecnico-projeto' })
          }
          )
          .catch(erro => {
            $('#salvar').button('reset');
            this.$mensagemErro(erro, 'Erro ao salvar o relatório técnico do projeto.');
          });
      },
      enviar(valido) {
        if (!valido) throw new Error("validacao com erro");

        const copiaRelatorioTecnicoProjeto = JSON.parse(JSON.stringify(this.relatorioTecnicoProjeto));

        copiaRelatorioTecnicoProjeto.arquivosDeletados = this.$refs.listaArquivos.deletados;

        return relatorioTecnicoProjetoServico.alterar(copiaRelatorioTecnicoProjeto, this.$refs.adicionarArquivos.arquivos, this.$route.params.id);
      },
      camposRelatorioTecnico() {
        return {
          idAcompanhamentoProjeto: null,
          idProjeto: null,
          numeroRelatorio: '',
          periodoRelatorioInicio: '',
          periodoRelatorioFim: '',
          previsaoConclusao: '',
          atividadesIniciadas: "false",
          atividadesIniciadasJustificativa: '',
          cronogramaCumprido: "false",
          cronogramaCumpridoJustificativa: '',
          planoOrcamentoCumprido: "false",
          planoOrcamentoCumpridoJustificativa: '',
          normasRespeitadas: "false",
          normasRespeitadasJustificativa: '',        
          intercorrencia: "false",
          intercorrenciaJustificativa: '',
          lei95894: "false",
          lei95894Justificativa: '',
          projetoAndamento: "false",
          projetoAndamentoJustificativa: '',
          comentariosAdicionais: '',
          dataAssinatura: '',
          idAssinatura: null,
          idResponsavelEnvio: 0,
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
          },
        };
      },
      carregar(id) {
        this.carregando = true;

        let relattecnico = null;

        relatorioTecnicoProjetoServico
          .obterPorId(id)
          .then(dados => {
            relattecnico = dados;
          })
          .then(() => relatorioTecnicoProjetoServico.arquivos(relattecnico.idAcompanhamentoProjeto))
          .then(arquivos => {
            this.arquivos = arquivos;
          })
          .then(() => {
            this.$set(this, 'relatorioTecnicoProjeto', relattecnico);
            this.carregando = false;
            this.setaVisibilidade();
          });
      },
      resetarComponente() {
        Object.assign(this.$data, this.$options.data.apply(this));
      },
      download(arquivo) {
        relatorioTecnicoProjetoServico
          .download(this.$route.params.idrelatorioTecnico, arquivo)
          .then(arquivo => {
            arquivo.download();
          });
      },
    },
    created() {
      if (this.$route.params.id) {
        this.$set(this, 'mostrarFormulario', true);
        this.carregar(this.$route.params.id);
      }
    },
    watch: {
    }
  }
</script>

<template>
  <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao">
    <form>

      <div class="row" v-if="mostrarFormulario">
        <div class="col-xs-12">
          <div class="ibox float-e-margins" v-if="carregando">
            <div class="ibox-content">
              <p class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>
            </div>
          </div>

          <div class="tabs-container" v-show="!carregando" id="tabs">
            <ul class="nav nav-tabs">
              <li class="active">
                <a data-toggle="tab"
                   href="#tab-dados-cadastrais">
                  Questionário
                </a>
              </li>

              <li v-if="relatorioTecnicoProjeto.pendenciasRelatorio !== ''">
                <a data-toggle="tab"
                   href="#tab-pendencia">
                  Pend&ecirc;ncias
                </a>
              </li>

              <li v-if="configuracao.pastaBaseAcompanhamentoProjeto !== ''">
                <a data-toggle="tab"
                   href="#tab-adicionar-arquivos">
                  Adicionar arquivos
                </a>
              </li>

              <li v-if="$route.params.id && (configuracao.pastaBaseAcompanhamentoProjeto !== '')">
                <a data-toggle="tab"
                   href="#tab-lista-arquivos">
                  Arquivos
                </a>
              </li>
            </ul>
            <div class="tab-content">

              <div id="tab-dados-cadastrais" class="tab-pane active">
                <div class="panel-body">
                  <dados-cadastrais ref="dadosCadastrais"
                                    :relatorioTecnicoProjeto="relatorioTecnicoProjeto"
                                    :edicao="!!$route.params.id"
                                    :readonly="camposReadOnly">
                  </dados-cadastrais>
                </div>
              </div>

              <div id="tab-pendencia" class="tab-pane">
                <div class="panel-body">
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="form-group" >
                        <textarea class="form-control" style="height: 700px;"
                                  id="pendencia"
                                  data-vv-name="pendencia"
                                  v-model="relatorioTecnicoProjeto.pendenciasRelatorio"
                                  readonly="readonly">
                        </textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div id="tab-adicionar-arquivos" class="tab-pane">
                <div class="panel-body">
                  <adicionar-arquivos ref="adicionarArquivos">
                  </adicionar-arquivos>
                </div>
              </div>

              <div id="tab-lista-arquivos" class="tab-pane">
                <div class="panel-body">
                  <lista-de-arquivos :arquivos="arquivos"
                                     @download="download"
                                     ref="listaArquivos">
                  </lista-de-arquivos>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
     
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <router-link class="btn btn-default"
                         :to="{ name: 'relatorio-tecnico-projeto' }"
                         v-show="!mostrarFormulario || !!$route.params.id"
                         active-class="">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </router-link>

            <button type="button"
                    class="btn btn-default"
                    @click="resetarComponente()"
                    v-show="mostrarFormulario && !(!!$route.params.id)">
              <i class="fa fa-arrow-left"></i>
              Volta
            </button>

            <button id="salvar"
                    type="button"
                    class="btn btn-primary"
                    @click="salvar"
                    v-show="botaoSalvar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Salvando...">
              <i class="fa fa-save"></i>
              Salvar
            </button>
          </div>
        </div>
      </div>
      
    </form>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio-tecnico-projeto/componentes/RelatorioTecnicoProjetoForm.vue